import { render, staticRenderFns } from "./question_type_fill.vue?vue&type=template&id=50f2e54e&scoped=true"
import script from "./question_type_fill.vue?vue&type=script&lang=js"
export * from "./question_type_fill.vue?vue&type=script&lang=js"
import style0 from "./question_type_fill.vue?vue&type=style&index=0&id=50f2e54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2e54e",
  null
  
)

export default component.exports